import React, { Fragment } from "react";
import Slider from "react-slick";
import SectionTitle from "../common/section_title";
import EventBox from "../common/event_box";
import { getAssets } from "@unisearch/helpers";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./styles/home.module.scss";

const img_01 = getAssets("assets/images/event-01.png");

export const UpcomingEvents = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const data = {
    event_time: "06.00 pm August 18, 2020",
    event_title: "Global Education Fall Meeting for Everyone",
    event_image: img_01,
  };

  return (
    <Fragment>
      <section className={styles.upcoming_events}>
        <div className="container">
          <SectionTitle shadow_text="EVENTS" title="Upcoming Events">
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's{" "}
            </p>
          </SectionTitle>
        </div>
        <div className={styles.event_container}>
          <Slider {...settings}>
            <div>
              <EventBox data={data} />
            </div>
            <div>
              <EventBox data={data} />
            </div>
            <div>
              <EventBox data={data} />
            </div>
            <div>
              <EventBox data={data} />
            </div>
            <div>
              <EventBox data={data} />
            </div>
            <div>
              <EventBox data={data} />
            </div>
            <div>
              <EventBox data={data} />
            </div>
            <div>
              <EventBox data={data} />
            </div>
          </Slider>
        </div>
        <div className="full-width">
          <div className="row">
            <div className="col-md-12 text-center">
              <button className="btn_primary mb-3">View All Country</button>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default UpcomingEvents;
